/**
 * Procedure Categories and Procedures for DM in Infectious Diseases students
 * Extracted with strict evidence from official NMC PDF (Page 9, 10, 16, 17: "Psychomotor domain - Must do independently")
 */
export const INFECTIOUS_DISEASES_PROCEDURES = {
  "Diagnostic Microbiology, Staining & Rapid Testing Procedures": [
    "Gram Stain of Exudates, Pus & Body Fluids",
    "Sputum Acid-Fast Bacillus (AFB) Staining for Tuberculosis",
    "Peripheral Blood Smear Microscopy for Malaria Parasite & Parasites",
    "KOH Wet Mount & Fungal Staining for Candida and Mycoses",
    "Rapid Diagnostic Tests (RDT) & Point-of-Care Tests (Tropical Fevers / HIV / HBV / HCV)",
    "Enzyme-Linked Immunosorbent Assay (ELISA) for Infectious Pathogens",
  ],
  "Invasive Diagnostic, Endoscopic & Critical Care Procedures": [
    "Central Venous Cannulation (Central Line Access)",
    "Basic & Advanced Life Support (BLS / ACLS / ATLS)",
    "Bone Marrow Aspiration & Trephine Biopsy",
    "Body Fluid Aspiration (Paracentesis, Thoracocentesis, Arthrocentesis)",
    "Image-Guided Diagnostic & Therapeutic Aspirations",
    "Diagnostic & Therapeutic Bronchoscopy (Lung & Airway Infections)",
    "Upper GI Endoscopy & Colonoscopy for Gastrointestinal Infections",
    "Point-of-Care Ultrasonography (POCUS) in Infectious Diseases",
  ],
};

export const INFECTIOUS_DISEASES_CATEGORIES = Object.keys(INFECTIOUS_DISEASES_PROCEDURES);

export const isDMInInfectiousDiseasesDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("infectious") || d.includes("infectious diseases");
};
